document.addEventListener("DOMContentLoaded", () => {
  const filters = document.querySelector("#main-collection-filters");
  let header = document.querySelector(".section-header .header");
  let headerH = header.offsetHeight - 1;

  if (!header || !filters) return;

  window.addEventListener("resize", () => {
    header = document.querySelector(".section-header .header");
  });

  const updateFilters = () => {
    console.log('scrolllll', window.scrollY)
    if (window.scrollY > 50) {
      filters.style.top = `${headerH}px`;
      filters.classList.add("main-collection-filters-sticky");
    } else {
      filters.style.top = "";
      filters.classList.remove("main-collection-filters-sticky");
    }
  };

  updateFilters();

  window.addEventListener("scroll", updateFilters);
});
